import React from "react";
import { Cake, Gift, Mail, Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSeo } from "@/lib/seo";
import { PawField } from "@/components/decor";
import PupBirthdayForm from "@/components/PupBirthdayForm";

const Step = ({ icon: Icon, title, text, color }) => (
  <div className="flex items-start gap-3">
    <span className="w-10 h-10 rounded-2xl flex items-center justify-center shrink-0" style={{ background: `${color}22` }}><Icon className="w-5 h-5" style={{ color }} /></span>
    <div><p className="font-display font-bold text-[#19324A]">{title}</p><p className="text-sm text-[#19324A]/70">{text}</p></div>
  </div>
);

export default function PupBirthdayClub() {
  useSeo("Pup Birthday Club", "Tell us your bulldog's birthday and we'll send a 15% treat code the week it rolls around.");
  const { user } = useAuth();
  return (
    <div className="relative overflow-hidden">
      <PawField color="#FF6B9D" opacity={0.07} />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-20 grid lg:grid-cols-2 gap-10 items-start">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-[#FFD93D] text-[#19324A] text-xs font-bold uppercase tracking-[0.18em] px-4 py-1.5" data-testid="birthday-club-badge"><Cake className="w-4 h-4" /> Pack perk</span>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-[#19324A] leading-[1.05] mt-5" data-testid="birthday-club-title">The Pup Birthday Club 🎂</h1>
          <p className="text-base md:text-lg text-[#19324A]/75 mt-5 max-w-lg">Every good dog deserves a birthday present. Tell us when your bulldog's big day is and Chewie &amp; Solo will send a <strong className="text-[#FF6B9D]">15% treat code</strong> a week before — just in time to pick something special.</p>
          <div className="mt-8 space-y-5">
            <Step icon={Heart} color="#FF6B9D" title="Add your pup" text="Name and birthday. Add as many bulldogs as live under your roof." />
            <Step icon={Mail} color="#4CC9F0" title="We'll remember" text="Seven days before the birthday, a treat code lands in your inbox. Every year." />
            <Step icon={Gift} color="#7ED957" title="Spoil them" text="15% off anything in the shop — bandanas, toys, books, or something for the human." />
          </div>
          <p className="text-xs text-[#19324A]/50 mt-8">Joining the club adds you to The Happy Bulldog Pack newsletter (sneak peeks, early access, the occasional treat). Unsubscribe any time.</p>
        </div>
        <div className="bg-white rounded-[2rem] soft-shadow p-6 sm:p-8" data-testid="birthday-club-card">
          <h2 className="font-display font-bold text-base md:text-lg text-[#19324A] mb-4">Add your bulldog</h2>
          <PupBirthdayForm defaultEmail={user?.email || ""} defaultName={user?.name?.split(" ")[0] || ""} />
        </div>
      </div>
    </div>
  );
}
